import tag from "../types/tag";
import { Itter } from "../utils/utils";

export default function placeholderTags() {
  return Itter<tag>(30, i => {
    return { id: i.toString(), tag: "Placeholder", response: "Placeholder Content", attachment: null, attachmentMime: null}
  })
}